import React, {Component} from 'react';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {Route, Switch, Redirect} from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify';

import MainApp from 'routes/app'
import AcquisitionKiosk from 'routes/app/routes/acquisitions/components/AcquisitionKiosk';
import PageRegister from 'routes/register/'
import PageForgotPassword from 'routes/forgot-password/'
import PageLogin from 'routes/login/'
import Framework from '@beardeddevops/react.framework';
import {locationHasModule, accountHasModule} from "components/Utilities";

import 'react-toastify/dist/ReactToastify.css';
import 'font-awesome/css/font-awesome.css';
import '@beardeddevops/react.framework/dist/index.css';

import lightTheme from './themes/lightTheme';
import 'constants/Styles.scss';

import API from "@beardeddevops/react.api";
import APPCONFIG from "constants/Config";
import Types from 'constants/Types';
import {defaultState} from 'constants/State';
import {
	ACQUISITION_KIOSK_MODE,
	clearAcquisitionKioskSession,
	getAcquisitionKioskLockedPath,
	getAcquisitionKioskSession,
	isAcquisitionKioskPathname,
} from 'constants/AcquisitionKiosk';

export default class App extends Component {

	constructor(props) {
		super(props);

		APPCONFIG.settings.apiURLOverride = window.localStorage.getItem('apiURLOverride') || null;
		API.URL = APPCONFIG.settings.apiURL();
		API.Version = APPCONFIG.settings.apiVersion;
		API.UrlsToSuppress = [
			'/accounts/details',
			'/accounts/check',
			'/dispositions/pendings/0',
		];
		API.setAJAXDefaults(this, toast);

		this.state = {};
		this.state.startLoading = false;
		this.sessionCheckingInitialized = false;
		/**
		 * @type {?ScannedCode}
		 */
		this.state.scannedCode = null;
		this.initialized_scanners = false;
		this.scanner_tracking = false;
		this.scanner_might_track = false;
		this.scanner_current_word = "";
		this.scanner_is_timed = false;
		this.lastInput = null;
	}

	async componentDidMount() {
		const {rootState} = this.props;

		// These values can be null so rootState knows to render when these state props change,
		// or optionally in addition, a callback that fires on change. rootState.set will do nothing
		// for properties that are not declared in a subscribe call in at least one component.
		// If all components using a property unsubscribe from a property's usage, rootState doesn't set state.
		// Properties defined here not declared in root state are treated as actions that can be called via
		// rootState.triggerAction - this allows child components deep in the tree to call container methods without
		// drilling the method through components between them, e.g. reloadShell (TODO). This should result
		// in the main thread spending less CPU time invoking callbacks at each component level.
		this.rootStateID = rootState.subscribe({
			name: null,
			account: null,
			userAccess: null,
			user: null,
			leepUsername: null,
			leepPassword: null,
			fflbossPosCombo: null,
			locations: null,
			states: null,
			kiosks: null,
			locationsCount: null,
			userCount: null,
			hasPawnModule: null,
			hasNFAModule: null,
			hasSecurityModule: null,
			hasManufacturingModule: null,
			hasImageCompressionModule: null,
			hasCloudModule: null,
			kioskMode: null,
			kioskLocation: null,
			kioskLocationBinaryId: null,
			isAdmin: null,
			hasPin: null,
			isLockedDown: null,
			getUserInformation: this.getUserInformation,
			logout: this.handleLogout,
			logout_admin: this.handleLogoutAdmin,

			//test
			locationSelected: null
		});

		await API.loadOptions(true, APPCONFIG.settings.apiVersion);

		// Determine session state
		await this.getUserInformation(this.props.location);

		// Start loading router tree
		this.setState({startLoading: true});

		let lastLocation = this.props.history.location.pathname;
		// Initial routing is done, reload account info on route change
		this.props.history.listen(async (location) => {
			if (lastLocation !== this.props.history.location.pathname) {
				lastLocation = this.props.history.location.pathname;
				await this.getUserInformation(location);
			}
		});

		//Don't wait for this one
		this.handleSubscriptionsCheck().then();
	}

	componentWillUnmount() {
		// Components need to unsubscribe from state events when unmounting, otherwise it will prevent garbage
		// collection, cause memory leaks from lingering callback references, and React will show warnings
		// about setting state in unmounted components.
		this.props.rootState.unsubscribe(this.rootStateID);
		clearInterval(this.handlingSessionChecks);
	}

	handleLogout = () => {
		this.props.rootState.set({...defaultState});
		this.props.history.push('/login');
	}

	handleLogoutAdmin = () => {
		this.props.rootState.set({...defaultState});
		window.location.href = APPCONFIG.settings.adminURL();
	}

	enforceAcquisitionKioskRoute = (location = this.props.location, kioskMode = ACQUISITION_KIOSK_MODE) => {
		if (String(kioskMode) !== String(ACQUISITION_KIOSK_MODE)) {
			clearAcquisitionKioskSession();
			if (location && isAcquisitionKioskPathname(location.pathname)) {
				this.props.history.replace('/acquisitions');
				return true;
			}
			return false;
		}

		const lockedPath = getAcquisitionKioskLockedPath();

		if (!lockedPath || !location || location.pathname === lockedPath) {
			return false;
		}

		if (this.props.history.location.pathname !== lockedPath) {
			this.props.history.replace(lockedPath);
		}

		return true;
	}

	getUserInformation = async (location) => {
		const {rootState} = this.props;

		let info = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
		let data;

		try {
			data = await info.submit(null, 'GET_DETAILS');
		} catch (e) {
			//throw new Framework.Errors.MissingAPIRouteError(e.message);
			return;
		}
		if (!data) {
			return;
		}

		const {
			locations,
			locations_count,
			users_count,
			kiosks,
			kiosk_mode,
			kiosk_location,
			kiosk_location_binary_id,
			account_modules,
			states
		} = data;
		const nextIsAdmin = typeof data.admin !== 'undefined' ? data.admin : false;

		/**
		 * @object data
		 * @property server
		 * @property servers
		 * @property name_first
		 * @property name_last
		 * @property user_access
		 * @property leep_username
		 * @property leep_password
		 * @property account_first
		 * @property account_last
		 * @property kiosk_location
		 * @property kiosk_location_binary_id
			* @property has_pin
			* @property is_locked_down
			* @property has_inactive_location_subscription
		 */
		const rootStatePayload = {
			account_number: data.account_number,
			all_locations_expired: data.all_locations_expired,
			name: data.name_first + " " + data.name_last,
			account: data.account_first + " " + data.account_last,
			userAccess: data.user_access,
			user: data.user,
			leepUsername: data.leep_username,
			leepPassword: data.leep_password,
			fflbossPosCombo: data.fflboss_pos_combo,
			locations,
			locationsCount: locations_count,
			userCount: users_count,
			hasPawnModule: locationHasModule(locations, 'module_pawn'),
			hasSecurityModule: accountHasModule(account_modules, 'module_security'),
			//Kiosk Required Fields: enforced flag (toggle ON + active module-5 subscription) from accounts/check
			kioskRequiredFields: data.force_4473_fields,
			//CRM: availability flag (active module-26 "CRM" subscription) from accounts/check
			crmAvailable: data.crm_available === true,
			hasNFAModule: locationHasModule(locations, 'module_nfa'),
			hasManufacturingModule: locationHasModule(locations, 'module_manufacturing'),
			hasImporterModule: locationHasModule(locations, 'module_importer'),
			hasInactiveLocationSubscription: data.has_inactive_location_subscription,
			hasDavidsonsModule: locationHasModule(locations, 'module_davidsons'),
			hasUtahModule: locationHasModule(locations, 'module_utah'),
			hasTransferShippingLabelModule: locationHasModule(locations, 'module_transfer_label'),
			hasCloudModule: locationHasModule(locations,'module_cloud'),
			hasAutoAcquisitionModule: locationHasModule(locations, 'module_acquisition'),
			hasMichiganRIModule: locationHasModule(locations, 'module_mi_ri_060'),
			hasNYP12Module: locationHasModule(locations, 'module_ny_p12'),
			hasAmmoreadyModule: locationHasModule(locations, 'module_ammoready'),
			hasGunbrokerModule: locationHasModule(locations, 'module_gunbroker'),
			hasTwinCityPawnModule: locationHasModule(locations, 'module_twin_city_pawns'),
			hasCustomExportsModule: locationHasModule(locations, 'module_custom_exports'),
			hasRI060AModule: locationHasModule(locations, 'module_mi_ri_060a'),
			hasRIComboModule: locationHasModule(locations, 'module_mi_ri_combo'),
			hasGunsAmericaModule: locationHasModule(locations, 'module_gunsamerica'),
			hasImageCompressionModule: locationHasModule(locations, 'module_compression'),
			hasRangeManager: data.has_range_manager,
			hasErpModule: locationHasModule(locations, 'module_erp'),
			kiosks,
			pendingsCount: data.pendings_count,
			persists_banner: data.persists_banner,
			persists_user_access: data.persists_user_access,
			location_banner: data.location_banner,
			location_user_access: data.location_user_access,
			locations_about_to_expire: data.locations_about_to_expire,
			hasPin: data.has_pin,
			isLockedDown: data.is_locked_down,
			states: states,
			notifications: data.notifications ?? [],
			pending_acquisitions: data.pending_acquisitions,
			davidsons_account_number: data.davidsons_account_number,
			arrow_setting: data.arrow_setting,
		};

		if (String(kiosk_mode) === String(ACQUISITION_KIOSK_MODE)) {
			rootState.set({
				...rootStatePayload,
				kioskMode: '',
				kioskLocation: '',
				kioskLocationBinaryId: '',
				isAdmin: nextIsAdmin,
			});
		} else {
			clearAcquisitionKioskSession();
			rootState.set({
				...rootStatePayload,
				kioskMode: kiosk_mode,
				kioskLocation: kiosk_location,
				kioskLocationBinaryId: kiosk_location_binary_id,
				isAdmin: nextIsAdmin,
			});
		}

		//TODO: need to properly gate this off modules when they are implemented
		//change the brand here in this order: RangeManagr, ERP, POS, Cloud, Normal

		if (data.has_range_manager) {
			APPCONFIG.brand = 'FFL Boss + RangeManagr';
		} else if (locationHasModule(locations, 'module_erp')) {
			APPCONFIG.brand = 'FFL Boss + ERP';
		} else if (data.has_pos) {
			APPCONFIG.brand = 'FFL Boss + POS';
		} else if (locationHasModule(locations, 'module_cloud')) {
			APPCONFIG.brand = 'FFL Boss + Cloud';
		} else {
			APPCONFIG.brand = 'FFL Boss';
		}

		const acquisitionKioskMode = String(data.kiosk_mode) === String(ACQUISITION_KIOSK_MODE);

		// API.Domains = data.servers;
		// let server = data.servers.find(server => server === data.server);
		// console.log('Should Update Server', !APPCONFIG.settings.apiURLOverride, server);
		// //If their server is online again then just force back to it.
		// if (server !== null) {
		// 	console.log('Updating api to accounts assigned server.');
		// 	//Set them to their default server sense its online so they will always default to their default server
		// 	window.localStorage.setItem('apiURLOverride', data.server);
		// 	API.URL = data.server;
		// }

		if (!acquisitionKioskMode && location != null && locations_count === 0 && location.pathname !== '/locations') {
			this.props.history.push('/locations');
		}

		let kioskCustomer = ['/dispositions/one_page', '/dispositions/one_page/0'];

		if (!acquisitionKioskMode && data.kiosk_mode.toString() === '1' && location != null && !kioskCustomer.includes(location.pathname)) {
			this.props.history.push('/dispositions/one_page');
		}

		if (!acquisitionKioskMode && data.kiosk_mode.toString() === '2' && kiosk_location_binary_id && kiosk_location) {
			let kioskPathname = `/locations/${kiosk_location_binary_id}-${kiosk_location}`;
			if (location && !location.pathname.startsWith(kioskPathname) && !location.pathname.startsWith('/dispositions/')) {
				this.props.history.push(`/locations/${kiosk_location_binary_id}-${kiosk_location}`);
			}
		}

		this.enforceAcquisitionKioskRoute(location, data.kiosk_mode);

		// Initialize services depending on an authenticated session
		await this.initSessionChecks();
		await this.initScanners();
	}

	handleSessionCheck = async () => {
		let lockedLocations = ['/login', '/register', '/forgot-password'];
		let kioskCustomer = ['/dispositions/one_page', '/dispositions/one_page/0'];

		let check = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
		let data = await check.submit(null, 'GET_CHECK');
		let OtherDomains = API.Domains.filter(domain => domain !== API.URL);
		for (let domain of OtherDomains) {
			check.submit(null, 'GET_CHECK', false, false, false, domain).then();
		}

		const {kiosk_mode, kiosk_location, kiosk_location_binary_id, admin} = data;

		/**
		 * @object data
		 * @property kiosk_mode
		 * @property kiosk_location
		 * @property kiosk_location_binary_id
		 */

		const nextIsAdmin = typeof admin !== 'undefined' ? admin : false;
		if (String(kiosk_mode) === String(ACQUISITION_KIOSK_MODE)) {
			this.props.rootState.set({
				kioskMode: '',
				kioskLocation: '',
				kioskLocationBinaryId: '',
				isAdmin: nextIsAdmin,
			});
			this.enforceAcquisitionKioskRoute(this.props.location, kiosk_mode);
			return;
		}

		this.enforceAcquisitionKioskRoute(this.props.location, kiosk_mode);
		this.props.rootState.set({
			kioskMode: kiosk_mode,
			kioskLocation: kiosk_location,
			kioskLocationBinaryId: kiosk_location_binary_id,
			isAdmin: nextIsAdmin,
		});

		//If your on a locked location but logged in then redirect
		if (lockedLocations.includes(this.props.location.pathname)) {
			if (this.props.location.pathname !== '/dashboard' || this.props.location.pathname !== '/') {
				this.props.history.push('/dashboard');
				return;
			}
		}

		//If your on a locked location but logged in then redirect
		if (kiosk_mode.toString() === '1' && !kioskCustomer.includes(this.props.location.pathname)) {
			//This will always remove the /0 from Edit Previous but that is okay because it protects everything else.
			// this.props.history.push('/dispositions/one_page');
		}

		if (kiosk_mode.toString() === '2' && kiosk_location_binary_id && kiosk_location) {
			let kioskPathname = `/locations/${kiosk_location_binary_id}-${kiosk_location}`;
			if (!this.props.location.pathname.startsWith(kioskPathname) && !this.props.location.pathname.startsWith('/dispositions/')) {
				this.props.history.push(`/locations/${kiosk_location_binary_id}-${kiosk_location}`);
			}
		}
	}

	initSessionChecks = async () => {
		if (this.sessionCheckingInitialized) return;

		await this.handleSessionCheck();

		this.handlingSessionChecks = setInterval(async () => {
			await this.handleSessionCheck();
		}, 60000);

		this.sessionCheckingInitialized = true;
	}

	handleSubscriptionsCheck = async () => {
		let check = new API.BuildClass(Types.Accounts_Subscriptions._name, API.RequestType.READ);
		await check.submit(null, 'GET_VERIFY');
	}

	initScanners() {
		if (this.initialized_scanners) return;

		this.initialized_scanners = true;
		let char = null;
		let prevChar = null;
		// document.addEventListener("keydown", function (event) {
		// 	if (event.ctrlKey) {
		// 		event.preventDefault();
		// 	}
		// });
		$(window).keypress(function (e) {
			if (!$(document.activeElement).is("input") &&
				!$(document.activeElement).is("textarea") &&
				!$(document.activeElement).is("select")) {

				if (document.activeElement) {
					$(document.activeElement).blur();
				}

				let key = e.which;
				//do stuff with "key" here...
				prevChar = char;
				char = String.fromCharCode(e.keyCode);

				if (this.scanner_tracking === false) {
					//LOOK FOR OUR STARTING CHARACTER
					if (this.scanner_might_track === false) {
						if (char === 'I' || char === "P") {
							this.scanner_tracking = true;
							this.scanner_current_word = char;
							this.scanner_might_track = false;
							this.scanner_is_timed = false;
							return;
						}
					}

					// LOOK FOR SPECIAL PREFIX IDs
					// Special Characters to Start Looking For
					if (this.scanner_might_track === false && (char === 'A' || char === 'B' || char === 'J' || char === 'N')) {
						this.scanner_might_track = char;
						return;
					}
					if (this.scanner_might_track !== false && this.scanner_might_track !== true) {
						let matched = false;
						let matches = ['AIM', 'BDO', 'JFP', 'NGL'];
						for (let i = 0; i < matches.length; i++) {
							let match = matches[i];

							if (match.substr(0, this.scanner_might_track.length + 1) === this.scanner_might_track + char) {
								matched = true;
								this.scanner_might_track = this.scanner_might_track + char;
								if (this.scanner_might_track === match) {
									this.scanner_tracking = true;
									this.scanner_current_word = match;
									this.scanner_might_track = true;
									this.scanner_is_timed = false;
									return;
								}
								return;
							}
						}
						if (matched === false) {
							this.scanner_might_track = false;
						}
					}

					if (Date.now() - this.lastInput < 50) {
						this.scanner_current_word = prevChar;
						this.scanner_tracking = true;
						this.scanner_is_timed = true;
					} else {
						this.scanner_tracking = false;
						this.scanner_current_word = "";
						this.scanner_might_track = false;
						this.scanner_is_timed = false;
					}
				}

				this.lastInput = Date.now();

				if (this.scanner_tracking === true) {

					if (!this.scanner_is_timed && ((this.scanner_current_word.length === 1 || (this.scanner_might_track === true && this.scanner_current_word.length === 3)) && char !== "-")) {
						this.scanner_tracking = false;
						this.scanner_current_word = "";
						this.scanner_might_track = false;
					}

					if (char === "-") {
						this.scanner_current_word += "-";
						return;
					}

					// enter key
					if (key === 13) {
						let scan = this.scanner_current_word + '\n';
						let product, prefix;
						if (this.scanner_is_timed) {
							product = scan;
							prefix = '';
						}
						else {
							let parts = scan.split('-');
							product = parts[1];
							if (parts[2]) {
								if (parts[1].length === 1) {
									parts[1] = '000' + parts[1];
								}
								product = parts[1] + '-' + parts[2];
							}
							prefix = parts[0];
						}
						this.scanner_tracking = false;
						this.scanner_current_word = "";
						this.scanner_might_track = false;
						this.scanner_is_timed = false;

						this.processScan(product, prefix);

						return;
					}

					this.scanner_current_word += char;

				} else {
					this.scanner_tracking = false;
					this.scanner_current_word = "";
					this.scanner_might_track = false;
					this.scanner_is_timed = false;
				}
			} else {
				this.scanner_tracking = false;
				this.scanner_current_word = "";
				this.scanner_might_track = false;
				this.scanner_is_timed = false;
			}
		}.bind(this));

	};

	/**
	 * @param barcode
	 * @param prefix
	 */
	processScan(barcode, prefix) {

		switch (this.props.location.pathname) {
			default:
				this.setState({
					scannedCode: {
						prefix: prefix,
						barcode: barcode
					}
				}, () => {
					this.setState({scannedCode: null});
				});
				break;
		}
	}

	render() {
		let {startLoading} = this.state;
		let {match, location, rootState} = this.props;
		let {account} = rootState;
		let materialUITheme = lightTheme;
		let isRoot = location.pathname === '/';
		const acquisitionKioskSession = getAcquisitionKioskSession();
		const shouldForceAcquisitionKiosk = !!acquisitionKioskSession && !isAcquisitionKioskPathname(location.pathname);

		// if (isRoot) {
		// 	API.NoLoggedInNotice = false;
		// 	return (
		// 		<Redirect to="/dashboard"/>
		// 	);
		// }

		return (
			<MuiThemeProvider theme={createMuiTheme(materialUITheme)}>
				<div id="app-inner">
					<div className="preloaderbar hide">
						<span className="bar"/>
					</div>
					<div className='app-main full-height fixed-header sidebar-sm'>
							{account ?
								shouldForceAcquisitionKiosk ?
									<Redirect to={getAcquisitionKioskLockedPath()}/>
									:
									<Switch>
										<Route exact path="/acquisitions/kiosk/:id?" component={AcquisitionKiosk}/>
										<Route
											path={`${match.url}`}
											render={(props) => (
												<MainApp
													{...props}
													scannedCode={this.state.scannedCode}
												/>
											)}
										/>
										<Redirect to="/"/>
									</Switch>
							: startLoading ?
								<Switch>
									<Route exact path="/login" component={PageLogin}/>
									<Route exact path="/register" component={PageRegister}/>
									<Route exact path="/forgot-password" component={PageForgotPassword}/>
								</Switch>
								:
								<Framework.Elements.LoadingSpinner isLoading={true}/>
						}
						<ToastContainer autoClose={10000} style={{
							textAlign: "center",
							width: 'auto',
							minWidth: '320px',
							maxWidth: '600px',
							marginLeft: 'auto',
							marginRight: 'auto',
							left: 0,
							right: 0
						}}/>
					</div>
				</div>
			</MuiThemeProvider>
		);
	}
}

App = Framework.Components.withRootState(App);
